<div class="container container-main">
  <app-dashboard-header #dashboardHeader :dashboardType="coach" />
  <div class="row mb-3">
    <div class="col-md-8">
      <ng-container *ngIf="smartAssistantEnabled">
        <div class="row gy-3 mb-3">
          <div class="col">
            <app-glai />
          </div>
        </div>
      </ng-container>
      <div class="row mb-3">
        <div class="col-md-6">
          <app-card-upcoming-sessions />
        </div>
        <div class="col-md-6">
          <app-card-evidence-for-review />
        </div>
      </div>
      <div *ngIf="!smartAssistantEnabled" class="row mb-3">
        <div class="col">
          <app-recent-celebration />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md">
          <app-card-coach-feedback />
          <app-card-todos *ngIf="!smartAssistantEnabled" />
          <app-card-ideas *ngIf="smartAssistantEnabled" />
        </div>
        <div class="col-md">
          <ng-container *ngIf="!smartAssistantEnabled">
            <app-coachee-list-card />
          </ng-container>
          <app-card-todos *ngIf="smartAssistantEnabled" />

          <app-card-ideas *ngIf="!smartAssistantEnabled" />
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <ng-container *ngIf="smartAssistantEnabled">
        <app-coachee-list-card />
      </ng-container>
      <ng-container *ngIf="instantFeedbackEnabled">
        <app-card-smart-feedback />
      </ng-container>
    </div>
  </div>
</div>
